export default "__VITE_ASSET__BGlIOswW__"